const initState = {
  athletes: [],
  singleAthlete: null,
  athleteCalc: [],
  registrationTotal: 0,
  chatTotal: 0,
  groupChatTotal: 0,
  licenseTotal: 0,
  fanRegistrationTotal: 0,
  orderTotal: 0,
};

const athleteReducer = (state = initState, action) => {
  switch (action.type) {
    case "GET_ATHLETES":
      return {
        ...state,
        athletes: action.payload,
      };
    case "GET_REGISTRATION_TOTAL":
      return {
        ...state,
        registrationTotal: action.payload,
      };
    case "GET_FAN_REGISTRATION_TOTAL":
      return {
        ...state,
        fanRegistrationTotal: action.payload,
      };
    case "ATHLETE_DATA_RECEIVED":
      return {
        ...state,
        singleAthlete: action.payload,
      };
    case "GET_CHAT_TOTAL_AMOUNT":
      return {
        ...state,
        chatTotal: action.payload,
      };
    case "GET_GROUP_CHAT_TOTAL_AMOUNT":
      return {
        ...state,
        groupChatTotal: action.payload,
      };
    case "GET_LICENSE_TOTAL_AMOUNT":
      return {
        ...state,
        licenseTotal: action.payload,
      };
    case "GET_ORDER_TOTAL_AMOUNT":
      return {
        ...state,
        orderTotal: action.payload,
      };
    case "GET_ATHLETE_CALCULATE":
      return {
        ...state,
        athleteCalc: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};
export default athleteReducer;
